<template>
  <div :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']" v-show="domStatus">
    <ProductConSwiper :imgUrls="imgUrls"></ProductConSwiper>
    <div class="nav acea-row row-between-wrapper">
      <div class="money">
        <span class="num" v-text="parseInt(storeInfo.price)"></span>积分<span class="y-money"
          v-text="'市场价: ￥' + storeInfo.ot_price"></span>
      </div>
      <div class="acea-row row-middle">
        <div class="iconfont icon-jiantou"></div>
      </div>
    </div>
    <div class="wrapperRush">
      <div class="introduce acea-row row-between">
        <div class="infor" v-text="storeInfo.title"></div>
        <!--        <div class="iconfont icon-fenxiang" @click="setPosterImageStatus"></div>-->
      </div>
      <div class="label acea-row row-middle">
        <!-- <div v-text="'销量:' + storeInfo.sales + '件'"></div> -->
      </div>
    </div>
    <div class="product-intro">
      <div class="title">产品介绍</div>
      <div class="conter" v-html="storeInfo.description"></div>
    </div>
    <div style="height:1.2rem;"></div>
    <div class="footerRush acea-row row-between-wrapper">
      <div class="bnt bg-color-red" @click="tapBuy">立即购买</div>
    </div>
    <PointsGoodWindow v-on:changeFun="changeFun" :attr="attr"></PointsGoodWindow>
    <StorePoster v-on:setPosterImageStatus="setPosterImageStatus" :posterImageStatus="posterImageStatus"
      :posterData="posterData"></StorePoster>
  </div>
</template>
<style scoped>
  .noscroll {
    height: 100%;
    overflow: hidden;
  }
</style>
<script>
  import ProductConSwiper from "@components/ProductConSwiper";
  import PointsGoodWindow from "@components/PointsGoodWindow";
  import StorePoster from "@components/StorePoster";
  import {
    getUserInfo
  } from '@/api/user.js'
  import {
    pointpro_detail
  } from "@api/store";
  import {
    postCartAdd
  } from "@api/store";
  import {
    imageBase64
  } from "@api/public";

  import {
    isWeixin
  } from "@utils";
  const _isWechat = isWeixin();

  const NAME = "PointsDetail";

  export default {
    name: "PointsDetail",
    components: {
      ProductConSwiper,
      PointsGoodWindow,
      StorePoster
    },
    props: {},
    data: function () {
      return {
        domStatus: false,
        points_id: null,
        posterData: {
          image: "",
          title: "",
          score: "",
          code: ""
        },
        posterImageStatus: false,
        action: "",
        imgUrls: [],
        storeInfo: [],
        replyCount: 0,
        reply: [],
        cartNum: 1,
        attr: {
          cartAttr: false,
          productSelect: {
            image: "",
            store_name: "",
            score: "",
            stock: "",
            unique: "",
            cart_num: 1
          }
        },
        datatime: 0,
        option: {
          id: null,
          type: null,
          time: null
        }
      };
    },
    watch: {
      $route: function (n) {
        var that = this;
        // console.log(n);
        if (n.name === NAME) {
          that.mountedStart();
        }
      }
    },
    mounted: function () {
      this.mountedStart();
      getUserInfo().then((res) => {
        // console.log(res, 'user');
        this.user = res.data
      })
    },
    methods: {
      mountedStart: function () {
        var that = this;
        this.points_id = that.$route.params.id;
        that.getPointsGoodDetail();
      },
      getPointsGoodDetail() {
        var that = this;
        pointpro_detail({
          id: that.points_id
        }).then(res => {
          // console.log(res);
          // return;
          that.$set(that, "storeInfo", res.data);
          let arr = []
          arr[0] = res.data.image
          that.$set(that, "imgUrls", arr);

          that.posterData.image = that.storeInfo.image;
          that.updateTitle();
          if (that.storeInfo.store_info.length > 30) {
            that.posterData.store_name =
              that.storeInfo.store_name.substring(0, 30) + "...";
          } else {
            that.posterData.store_name = that.storeInfo.store_name;
          }
          that.posterData.score = that.storeInfo.score;
          that.posterData.code = that.storeInfo.code_base;
          that.posterData.ot_price = that.storeInfo.ot_price;
          that.setProductSelect();
          that.domStatus = true;
          that.getImageBase64();
        });
      },
      getImageBase64: function () {
        let that = this;
        imageBase64(this.posterData.image, that.posterData.code)
          .then(res => {
            that.posterData.image = res.data.image;
            that.posterData.code = res.data.code;
          })
          .catch(res => {
            that.$dialog.error(res.msg);
          });
      },
      updateTitle() {
        document.title = this.storeInfo.store_name || this.$route.meta.title;
      },
      setPosterImageStatus: function () {
        var sTop = document.body || document.documentElement;
        sTop.scrollTop = 0;
        this.posterImageStatus = !this.posterImageStatus;
      },
      //将父级向子集多次传送的函数合二为一；
      changeFun: function (opt) {
        if (typeof opt !== "object") opt = {};
        let action = opt.action || "";
        let value = opt.value === undefined ? "" : opt.value;
        this[action] && this[action](value);
      },
      changeattr: function (res) {
        var that = this;
        that.attr.cartAttr = res;
      },
      ChangeCartNum: function (res) {
        var that = this;
        // console.log(res, 'ChangeCartNum')
        if (res == 'add') {
          let num = that.attr.productSelect.cart_num + 1
          let count = that.attr.productSelect.stock - that.attr.productSelect.sales
          if (num * that.attr.productSelect.score > that.user.integral) {
            that.$dialog.error('积分不足')
            return;
          }
          if (that.attr.productSelect.cart_num < count) {
            that.attr.productSelect.cart_num++;
          }
        } else {
          if (that.attr.productSelect.cart_num > 1) {
            that.attr.productSelect.cart_num--;
          }
        }
      },
      setProductSelect: function () {
        var that = this;
        var attr = that.attr;
        attr.productSelect.image = that.storeInfo.image;
        attr.productSelect.store_name = that.storeInfo.store_name;
        attr.productSelect.score = that.storeInfo.score;
        attr.productSelect.stock = that.storeInfo.stock;
        attr.productSelect.sales = that.storeInfo.sales;
        attr.cartAttr = false;
        that.$set(that, "attr", attr);
      },
      selecAttrTap: function () {
        this.cartAttr = true;
      },
      tapBuy: function () {
        var that = this;
        if (this.storeInfo.price === "请先登录") {
          if (_isWechat) {
            return this.$dialog.toast({
              mes: '请联系商城管理员审核'
            });
          } else {
            this.$router.push("/login");
          }
        }
        if (that.attr.cartAttr == false) {
          that.attr.cartAttr = !this.attr.attrcartAttr;
        } else {
          let num = that.attr.productSelect.cart_num
          if (num * that.attr.productSelect.score > that.user.integral) {
            that.$dialog.error('积分不足')
            return;
          }
          var data = {};
          data.productId = that.storeInfo.id;
          data.cartNum = that.attr.productSelect.cart_num;
          data.new = 1;
          postCartAdd(data)
            .then(res => {
              that.$router.push({
                path: "/order/submit/" + res.data.cartId,
                query: {
                  activity: 4
                }
              });
            })
            .catch(res => {
              this.$dialog.error(res.msg);
            });
        }
      }
    }
  };
</script>
<style scoped>
  .product-con .nav {
    padding: 0 0.2rem;
  }
</style>
